import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { UserConfiguration } from './_models';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SharedUserConfigurationService {
  private readonly baseUrl = '/sdapi/profile/userconfiguration';

  constructor(private readonly http: HttpClient) {}

  /** crud */
  getUserConfiguration(): Observable<UserConfiguration> {
    return this.http.get<UserConfiguration>(this.baseUrl).pipe(
      map((userConfiguration: UserConfiguration) => {
        if (userConfiguration) {
          userConfiguration.calendarConfiguration.initComplete = true;
        }
        return userConfiguration;
      })
    );
  }

  saveUserConfiguration(userConfiguration: UserConfiguration): Observable<UserConfiguration> {
    const url = userConfiguration.userConfigurationId
      ? `${this.baseUrl}/${userConfiguration.userConfigurationId}`
      : this.baseUrl;
    const verb = userConfiguration.userConfigurationId ? 'put' : 'post';
    return this.http[verb]<UserConfiguration>(url, userConfiguration);
  }
}
